import React, { useState } from "react";
import {
  Box,
  Container,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import {
  Storage as StorageIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import AdminPage from "./AdminPage";
import RedisCacheLookup from "../../components/backend/rediscache/RedisCacheLookup";
import RedisCacheStats from "../../components/backend/rediscache/RedisCacheStats";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`redis-cache-tabpanel-${index}`}
      aria-labelledby={`redis-cache-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const RedisCachePage: React.FC = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <AdminPage>
      <Container maxWidth="xl">
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
            {t("admin.redisCache.title")}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t("admin.redisCache.subtitle")}
          </Typography>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="redis cache tabs"
          >
            <Tab
              icon={<SearchIcon />}
              label={t("admin.redisCache.lookupProductTab")}
              iconPosition="start"
            />
            <Tab
              icon={<StorageIcon />}
              label={t("admin.redisCache.statisticsTab")}
              iconPosition="start"
            />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <RedisCacheLookup />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <RedisCacheStats />
        </TabPanel>
      </Container>
    </AdminPage>
  );
};

export default RedisCachePage;

